export default "__VITE_ASSET__9f630d6e__"